import React, { Component } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Job from '../job/job';
import './draggable-job-list.css';

const getItemStyle = (isDragging, draggableStyle) => ({
  ...draggableStyle
});

export default class DraggableJobList extends Component {

  onDragEnd = (result) => {

    if (!result.destination)
      return;

    this.props.onJobsReordered(result.source.index, result.destination.index);
  }

  render() {
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div 
              className="draggable-job-list-container"
              {...provided.droppableProps} 
              ref={provided.innerRef}>
              {this.props.jobs.map((job, index) => (
                <Draggable key={job.id} draggableId={"job_" + job.id} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={getItemStyle(
                        snapshot.isDragging,
                        provided.draggableProps.style
                      )}>
                      <Job 
                      job={job}
                      onMarkJobComplete={this.props.onMarkJobComplete}/>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }
}